import AddArtistForm from './artists/AddArtistForm'
import ArtistsList from './artists/ArtistsList'
import Artist from './artists/Artist'

export const Artists = {
    AddForm: AddArtistForm,
    List: ArtistsList,
    Name: Artist
}


// WEBPACK FOOTER //
// ./src/components/Artists.js